import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Spin, message } from 'antd';
import { cydCheckLogin } from '@/services/login';
import { setToken } from '@/utils/token';

export default function Callback() {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const authCode = searchParams.get('data');
    if (!authCode) {
      message.error('缺少授权参数');
      Navigate('/login');
      return;
    }

    cydCheckLogin(authCode).then((res) => {
      setToken(res?.token);
      dispatch({ type: 'USER_TYPE', payload: res?.userType });
      dispatch({ type: 'STATUS', payload: res?.materialStatus });
      if (res?.materialStatus) {
        Navigate('/authentication');
      } else {
        Navigate('/home');
      }
    }).catch(() => {
      Navigate('/login');
    });
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Spin size="large" tip="登录中..." />
    </div>
  );
}
